import PropTypes from 'prop-types';
import { attr, fk, Model } from 'redux-orm';

class PatientIntegrationsZus extends Model {
  static modelName = 'PatientIntegrationsZus';

  static fields = {
    id: attr(),
    athenaIntegrationId: attr(),
    athenaPracticeId: attr(),
    athenaPatientId: attr(),
    zusPatientId: attr(),
    zusUpid: attr(),
    status: attr(),
    lastSyncedAt: attr(),
    lastHistoryJobId: attr(),
    lastHistoryJobStatus: attr(),
    lastHistoryJobStartedAt: attr(),
    lastHistoryJobCompletedAt: attr(),
    deletedAt: attr(),
    createdAt: attr(),
    updatedAt: attr(),
    createdBy: fk('Client', 'patientIntegrationsZusCreator'),
    updatedBy: fk('Client', 'patientIntegrationsZusUpdater'),
    patientId: fk({
      to: 'Patient',
      as: 'patient',
      relatedName: 'patientIntegrationsZus',
    }),
  };

  static schema = {
    _fields: PropTypes.exact({
      id: PropTypes.string,
      athenaIntegrationId: PropTypes.string,
      athenaPracticeId: PropTypes.string,
      athenaPatientId: PropTypes.string,
      zusPatientId: PropTypes.string,
      zusUpid: PropTypes.string,
      status: PropTypes.string,
      lastSyncedAt: PropTypes.string,
      lastHistoryJobId: PropTypes.string,
      lastHistoryJobStatus: PropTypes.string,
      lastHistoryJobStartedAt: PropTypes.string,
      lastHistoryJobCompletedAt: PropTypes.string,
      deletedAt: PropTypes.string,
      createdAt: PropTypes.string,
      updatedAt: PropTypes.string,
      updatedBy: PropTypes.number,
      createdBy: PropTypes.number,
      patientId: PropTypes.number,
    }),
    patientId: PropTypes.number,
  };
}

export default PatientIntegrationsZus;
